export default __webpack_public_path__ + "static/zonaVMb-2448315ac2b04fb37400a24b2cc289a9.png";